import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { api, API } from './lib/api';
import LoginPage from './pages/LoginPage';
import AnalyticsPage from './pages/AnalyticsPage';
import './App.css';
import './mobile.css';

export default function App() {
  const isAnalytics = window.location.pathname.replace(/\/$/, '') === '/analytics';
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(isAnalytics);
  const [connectionError, setConnectionError] = useState(false);

  async function checkSession() {
    setChecking(true);
    setConnectionError(false);
    try { setUser(await api('/auth/me')); }
    catch (error) { if (error.status !== 401) setConnectionError(true); }
    finally { setChecking(false); }
  }
  useEffect(() => {
    document.title = isAnalytics ? 'Analytics · Bonds Beyond Blood' : 'Bonds Beyond Blood';
    if (isAnalytics) checkSession();
  }, [isAnalytics]);

  if (!isAnalytics) return <iframe data-testid="original-book-page" className="original-page" src={`${API}/page`} title="Bonds Beyond Blood by Ciel Essel" />;
  if (checking) return <div className="session-loading" data-testid="session-loading"><Loader2 className="animate-spin" size={22} /><span>Opening your ledger…</span></div>;
  if (!user) return <LoginPage onLogin={setUser} connectionError={connectionError} />;
  return <AnalyticsPage user={user} onLogout={() => setUser(null)} />;
}